<template>
  <z-expansion-config-item 
    :titulo="`Terminal (${terminal})`" 
    subtitulo="Selecione o número do terminal deste computador"
  >
    <v-select
      v-model="store.configuracoes.APP_TERMINAL"
      dense
      filled
      hide-details
      style="width: 200px"
      :items="gerarTerminais()"
      @change="updateConfig"
    ></v-select>
  </z-expansion-config-item>
</template>

<script setup>
// import { ref, onMounted } from 'vue';
import { gerarTerminais } from '@/app/helpers/utils';
import useCookie from '@/app/core/CookieCore';
import { useConfigStore } from '@/app/store/pinia/configuracoes'
import sistemaApi from '@/app/services/sistema';

const store = useConfigStore();

const cookie = useCookie();
const terminal = cookie.getCookie('terminal_id');
// const APP_TERMINAL = ref(null);

// onMounted(()=>{
//   APP_TERMINAL.value = store.configuracoes.APP_TERMINAL;
// })

async function updateConfig() {
  // cookie.setCookie('APP_TERMINAL', store.configuracoes.APP_TERMINAL, Infinity);
  sistemaApi.updateTerminalConfig({ 
    key: 'APP_TERMINAL', 
    value: store.configuracoes.APP_TERMINAL, 
  });
  // console.log(cookie.getCookie('APP_TERMINAL'));
}

</script>

<style lang="scss" scoped>

</style>
